import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import MainLayout from '@/components/MainLayout'
import DeviceManage from '@/components/DeviceManage'
import ChatroomManage from '@/components/ChatroomManage'
import BalanceManage from '@/components/BalanceManage'
import ClientManage from '@/components/ClientManage'
import BotManage from '@/components/BotManage'
import LogManage from '@/components/LogManage'
import Login from '@/components/Login'
// import GeneralManage from '@/components/GeneralManage'
import UserManage from '@/components/UserManage'
// import ChatroomBlackManage from '@/components/ChatroomBlackManage'
import BizManage from '@/components/BizManage'
import MaterialManage from '@/components/MaterialManage'
import ProviderManage from '@/components/ProviderManage'
import GroupSending from '../components/GroupSending'
import MyClient from '../components/MyClient'
import RaiseAccount from '../components/RaiseAccount'
import CreatRaisetask from '../components/CreatRaisetask'

Vue.use(Router)


// 解决报错  Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location: "/".
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/MainLayout',
      name: 'MainLayout',
      component: MainLayout,
      children: [
        {
          path: '/DeviceManage',
          name: 'DeviceManage',
          component: DeviceManage
        },
        {
          path: '/ChatroomManage',
          name: 'ChatroomManage',
          component: ChatroomManage
        },
        {
          path: '/BalanceManage',
          name: 'BalanceManage',
          component: BalanceManage
        },
        {
          path: '/ClientManage',
          name: 'ClientManage',
          component: ClientManage
        },
        {
          path: '/BotManage',
          name: 'BotManage',
          component: BotManage
        },
        {
          path: '/LogManage',
          name: 'LogManage',
          component: LogManage
        },
        // {
        //   path: '/GeneralManage',
        //   name: 'GeneralManage',
        //   component: GeneralManage
        // },
        {
          path: '/UserManage',
          name: 'UserManage',
          component: UserManage
        },
        {
          path: '/BizManage',
          name: 'BizManage',
          component: BizManage
        },
        {
          path: '/MaterialManage',
          name: 'MaterialManage',
          component: MaterialManage
        },
        {
          path: '/ProviderManage',
          name: 'ProviderManage',
          component: ProviderManage
        },
        // {
        //   path: '/ChatroomBlackManage',
        //   name: 'ChatroomBlackManage',
        //   component: ChatroomBlackManage
        // },
        {
          path: '/GroupSending',
          name: 'GroupSending',
          component: GroupSending
        },
        {
          path: '/MyClient',
          name: 'MyClient',
          component: MyClient
        },
        {
          path: '/RaiseAccount',
          name:'RaiseAccount',
          component: RaiseAccount
        },
        {
          path: '/CreatRaisetask',
          name:'CreatRaisetask',
          component: CreatRaisetask
        }
      ]
    }
  ]
})
